import EmailConfirmationModal from './EmailConfirmationModal';

export default class ForgotPasswordConfirmationModal extends EmailConfirmationModal {}
